import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "File4K"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M3 19.5225H21C21.8284 19.5225 22.5 18.8509 22.5 18.0225V6.02246C22.5 5.19403 21.8284 4.52246 21 4.52246H3C2.17157 4.52246 1.5 5.19403 1.5 6.02246V18.0225C1.5 18.8509 2.17157 19.5225 3 19.5225ZM3 18.0225V6.02246H21V18.0225H3ZM9 8.27246V11.2725H7.5V8.27246H6V12.7725H9V15.7725H10.5V8.27246H9ZM16.5 8.27246H18.1425L15.9 11.5575L18.1425 15.7725H16.5L14.9325 12.7275L14.25 13.725V15.7725H12.75V8.27246H14.25V11.565L16.5 8.27246Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/File4K.vue"]]);
